// extracted by mini-css-extract-plugin
module.exports = {"lang":"LangMenu_lang__3Acf-","langAfs":"LangMenu_langAfs__15yuU","langIpc":"LangMenu_langIpc__3r3lF","active":"LangMenu_active__2KPc9"};